import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'
import { formFilterPairs } from '../../../components/custom/AddPopup/AddPopupUtil'

const currentRevisionSelector = state => state.revisions.latestRevision

const revisionSelector = state => state.entities.revisions

export {
  revisionSelector,
  currentRevisionSelector
}
